let html = `<div class="ai-search-animation">
    <div class="ai-search-animation__data">{icon}</div>
    <div class="ai-search-animation__loupe">
        <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32.316" cy="32.6878" r="28.0054" stroke="white" stroke-width="8"/>
            <rect x="54.748" y="49.7433" width="32.3166" height="7.60373" rx="3.80187" transform="rotate(45 54.748 49.7433)" fill="currentColor"/>
        </svg>
    </div>
</div>`

export default html